import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import { ActionButton } from './actionButton';
import { useIssueParameters } from 'store/issue';
import { useIssueOverlayControls } from '../../../documentation/DocumentationDataGrid/components/IssueOverlayControls';
import { FiltersTranslationKeys } from 'intl/keys';
import { formatTranslation, unsafeTranslationKey } from 'intl';

const ISSUE_STATE_TITLE_KEY = {
  active: FiltersTranslationKeys.activeIssues,
  removed: FiltersTranslationKeys.removedIssues,
} as const;

interface IssueStateToggleButtonProps {
  isMobile: boolean;
}

export const IssueStateToggleButton: React.FC<
  IssueStateToggleButtonProps
> = ({ isMobile }) => {
  const intl = useIntl();
  const { filtersDisabled, filtersDisabledReason } = useIssueOverlayControls();

  const { parameters, setParameters } = useIssueParameters();
  const isArchived = parameters.deleted;
  const isPublishedState = !isArchived;

  const label = formatTranslation(
    intl,
    ISSUE_STATE_TITLE_KEY[isPublishedState ? 'active' : 'removed']
  );
  const tooltipTitle = filtersDisabled
    ? formatTranslation(intl, unsafeTranslationKey(filtersDisabledReason) )
    : label;

  const handleToggle = useCallback(() => {
    setParameters({ deleted: !isArchived, offset: 0 });
  }, [
    isArchived,
    setParameters,
  ]);

  return (
    <ActionButton
      isMobile={isMobile}
      onClick={handleToggle}
      disabled={filtersDisabled}
      tooltipTitle={tooltipTitle}
      label={label}
      icon={
        isPublishedState ? (
          <ToggleOnIcon sx={{ color: 'currentColor' }} />
        ) : (
          <ToggleOffIcon sx={{ color: 'currentColor' }} />
        )
      }
    />
  );
};
